document.addEventListener('alpine:init', () => {
  Alpine.store('cartCount', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    _revision: 0,
    _onUpdate: null,
    init() {
      if (this._onUpdate) return;
      this._onUpdate = (event) => this._setFromFetchedSection(event?.detail?.response);
      window.addEventListener('baseline:cart:afteradditem', this._onUpdate);
      window.addEventListener('baseline:cart:cartqtychange', this._onUpdate);
    },
    _setFromFetchedSection(data) {
      const revision = ++this._revision;
      try {
        const html = data?.sections?.['cart-item-count'];
        if (typeof html === 'string' && html.trim()) {
          const text = parseDOMFromString(html).firstElementChild?.textContent?.trim();
          if (text && /^\d+$/.test(text)) {
            this.count = Number(text);
            return;
          }
        }
        if (Number.isInteger(data?.item_count) && data.item_count >= 0) {
          this.count = data.item_count;
          return;
        }
      } catch (error) {
        console.warn('Hunted+Gathered cart count section was unreadable', error);
      }
      // Refresh only the display. Never replay a cart mutation to recover a badge.
      this._refreshCount(revision);
    },
    async _refreshCount(revision) {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision === this._revision && Number.isInteger(cart?.item_count) && cart.item_count >= 0) {
          this.count = cart.item_count;
        }
      } catch (error) {
        // Keep the last valid count; the full-cart link remains available.
        console.warn('Hunted+Gathered cart count could not refresh', error);
      }
    },
    countWithText() {
      const template = this.count === 1 ? theme.strings.itemCountOne : theme.strings.itemCountOther;
      return template.replace('{{ count }}', this.count);
    },
  });
});
